// Toast queue for the "a ticket just landed" pop-up, separate from
// notificationsStore (the durable bell queue) the same way primus-admin-main
// keeps alertToastStore separate from notificationsStore -- the toast is the
// thing you see immediately, the bell is what you catch up on if you missed it.

let toasts = [];
const listeners = new Set();
const MAX_STACK = 4;

function emit() {
  listeners.forEach((fn) => {
    try {
      fn(toasts);
    } catch (e) {
      console.error('ticketToastStore listener error', e);
    }
  });
}

export function subscribeTicketToasts(handler) {
  if (typeof handler !== 'function') return () => {};
  listeners.add(handler);
  handler(toasts);
  return () => {
    listeners.delete(handler);
  };
}

export function pushTicketToast(toast) {
  const id = toast.id || String(Date.now()) + Math.random().toString(36).slice(2);
  if (toasts.some((t) => t.id === id)) return id;
  toasts = [{ ...toast, id }, ...toasts].slice(0, MAX_STACK);
  emit();
  return id;
}

export function dismissTicketToast(id) {
  const next = toasts.filter((t) => t.id !== id);
  if (next.length !== toasts.length) {
    toasts = next;
    emit();
  }
}
